// extracted by mini-css-extract-plugin
export default {"dotloader":"loader-dots_dotloader__1vFoP","bouncedelay":"loader-dots_bouncedelay__SzeF5","dotloader1":"loader-dots_dotloader1__R2eXe","dotloader2":"loader-dots_dotloader2__h0JZd"};